/* global axios */
import ApiClient from './ApiClient';

class WhatsappCallsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getUrl(conversationId) {
    return `${this.url}/${conversationId}/calls`;
  }

  initiate(conversationId, sdpOffer) {
    return axios.post(this.getUrl(conversationId), { sdp_offer: sdpOffer });
  }

  requestPermission(conversationId) {
    return axios.post(`${this.getUrl(conversationId)}/request_permission`);
  }

  terminate(conversationId, callId) {
    return axios.post(`${this.getUrl(conversationId)}/${callId}/terminate`);
  }

  accept(conversationId, recordId, sdpAnswer) {
    return axios.post(`${this.getUrl(conversationId)}/${recordId}/accept`, {
      sdp_answer: sdpAnswer,
    });
  }

  iceServers(conversationId) {
    return axios.get(`${this.getUrl(conversationId)}/ice_servers`);
  }

  uploadRecording(conversationId, recordId, blob) {
    const form = new FormData();
    form.append('file', blob, `call-${recordId}.webm`);
    return axios.post(
      `${this.getUrl(conversationId)}/${recordId}/recording`,
      form
    );
  }
}

export default new WhatsappCallsAPI();
